import { OptionsIcon } from "assets/icons/OptionsIcon";
import { ModalDelete } from "components/ModalDelete/ModalDelete";
import { NormativaI } from "interfaces/Normativa";
import { ReactNode, useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";
import "../../../styles/general.css";

interface Props {
  elemento: NormativaI;
  renderActions?: (elemento: NormativaI) => ReactNode;
}

export const NormativasRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td className="row-descripcion">{elemento.descripcion}</td>
        <td>{elemento.tipoNormativa.nombre}</td>
        <td>{elemento.tipoEfecto.nombre}</td>
        <td>{elemento.alcance.nombre}</td>
        <td>
          {elemento?.aplicaValidezNacional ? (
            <Badge
              bg={"none"}
              style={{
                color: "#26874A",
                backgroundColor: "#F5FCF8",
                borderColor: "#26874A",
              }}
            >
              Activo
            </Badge>
          ) : (
            <Badge
              bg={"none"}
              style={{
                color: "#ff0000",
                backgroundColor: "#F5FCF8",
                borderColor: "#ff0000",
              }}
            >
              Inactivo
            </Badge>
          )}
        </td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
